module.exports = __webpack_public_path__ + "89c7836755e3cafbec06fab5d4695631.svg";